import { get } from 'lodash';
import routes from '../routes/Route.config';
import { fetchLonLatData } from '../modules/search/slice/listViewSlice';


export const configuredAEMUrl = (url) => {
  const { REACT_APP_BASEURL, REACT_APP_IMAGEURL } = window.weeksWebCloudConfig;
  if (process.env.NODE_ENV === 'development' && url && (url.includes('weeks-offer-details') || url.includes('feedback')) ) {
    return `${REACT_APP_IMAGEURL}${url}`;
  } else if (process.env.NODE_ENV === 'development') {
    return `${REACT_APP_BASEURL}${url}`;
  }
  return url;
};
export const getAEMCompName = (compObj, compKeyName) => {
  const compData = compObj[compKeyName];
  const compName = get(compData, 'componentname') || get(compData, 'componentName');
  if (compName === 'hotels') {
    if (compData.placement === 'A Spot' || compData.placement === 'D Spot') {
      const name = compData.placement.split(' ').join('');
      return `${name}-${compName}`;
    }
  }
  return compName;
};
export const getCookie = (cName) => {
  const name = cName + "=";
  const cDecoded = decodeURIComponent(document.cookie); //to be careful
  const cArr = cDecoded.split('; ');
  let res = false;
  cArr.forEach(val => {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  })
  return res
};

export const redirectTo = async (selectedData, calledFrom='search') => {
        const queryString = selectedData?.addLabel?.toString() || '';
        let setQuery = queryString.replace(/ /g, '');
        const propertyId = selectedData?.arnPropertyId || null;
        if(propertyId){
        setQuery = 'AIMsResort';
        }
        // return false;
        // Better validation function
        let resortId = '';
        if(setQuery.toLowerCase() === 'resort'|| setQuery.toLowerCase() === 'aimsresort'){
          const splitValue = selectedData?.referenceId?.toString().split(':');
          if (splitValue && splitValue.length === 2 && splitValue[0].toLowerCase() === 'rsrt') {
            resortId = splitValue[1];
          }
        }
        const isValidCoordinate = (value) => {
          return value !== null && 
                value !== undefined && 
                value !== 0 && 
                value !== '0' && 
                !isNaN(parseFloat(value)) && 
                isFinite(value);
        };
        if(selectedData?.latitude && selectedData?.longitude && 
          isValidCoordinate(selectedData.latitude) && 
          isValidCoordinate(selectedData.longitude)) {
          return {'url':`/search?query=${encodeURIComponent(selectedData?.label)}&lat=${selectedData.latitude}&long=${selectedData.longitude}`,
                        'type':'geocode'};
        }
            switch (setQuery) {
                case "Geocode":
                    selectedData = await fetchLonLatData(selectedData.value, selectedData);
                    return {'url':`/search?query=${encodeURIComponent(selectedData?.label)}&lat=${selectedData.latitude}&long=${selectedData.longitude}`,
                            'type':setQuery.toLowerCase()};
                case "RCIDictionaryGeocode":
                    // selectedData = await fetchLonLatData(selectedData.value, selectedData);
                    return {'url':`/search?query=${encodeURIComponent(selectedData?.label)}`,
                            'type':setQuery.toLowerCase()};
                case "Resort":
                    return {'url':`/availableunits?resortId=${resortId}&navFrom=${calledFrom}${calledFrom === 'search' ? '&triggeredFromSearch=true' : '&triggeredFromHeader=true'}`,
                            'type':setQuery.toLowerCase()};   
                case "AIMsResort":
                    return {'url':`/search?query=${encodeURIComponent(selectedData?.label)}&resortId=${resortId}`,
                            'type':setQuery.toLowerCase()};                                             
                default:
                    return {'url':`/search?query=${encodeURIComponent(selectedData?.label)}`,
                            'type':setQuery.toLowerCase()};
}
}

export const addFooterAndHeader = () => {
// Code starts to retain header component
        const headerComponent = document.querySelector('header-component');
        if (headerComponent) {
            headerComponent.remove();
        }
        const rootElement = document.getElementById('root');
        // eslint-disable-next-line no-undef
        if (rootElement && selfHeader) {
        // eslint-disable-next-line no-undef
            rootElement.insertAdjacentElement('afterend', selfHeader);
        }
        // Code ends to retain header component
        // Code starts to retain footer component
        const footerComponent = document.querySelector('custom-postrci-footer');
        if (footerComponent) {
            footerComponent.remove();
        }
        // const rootElement = document.getElementById('root');
        // eslint-disable-next-line no-undef
        if (rootElement && selfFooter) {
        // eslint-disable-next-line no-undef
            rootElement.insertAdjacentElement('afterend', selfFooter);
        }
        // Code ends to retain footer component
}

export const getPageUrl = (url, locale) => {
  const configuredUrl = url && url.replace('@@Country', locale.split('_')[1].toLowerCase()).replace('@@Lang', locale.split('_')[0].toLowerCase());
  return configuredUrl;

}
export const handleURLNavigationAEM = (attrName, history) => {
  const REACT_PAGES_URL = routes.map(route => route.path);
  const targetVal = '_self';
  if (!attrName) {
    return;
  }
  if (!attrName.startsWith('http') && !attrName.startsWith('https') && !attrName.includes('/post-')) {
    if (REACT_PAGES_URL.length>0 &&  REACT_PAGES_URL.includes(attrName)) {
      history.push(attrName);
    } else {
      window.open(attrName, targetVal);
    }
  } else {
    window.open(attrName, targetVal);
  }
};


export const scrollFocussedElementIntoView = (className) => {
  const els = document.querySelectorAll(className);
  if (els) {
    els.forEach(el => el.addEventListener('keydown', (e) => {
      if (e.key === 'Tab' || e.keyCode === 9) {
        setTimeout(() => {
          document.activeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'end' })
        }, 200);
      }
    }))
  }
}